import i18n from '@/plugins/i18n';
import type { DataTableHeader } from '@/types/vuetify';

export function createLivePageHeadersFootball(): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        {
            title: '',
            key: 'data-table-group',
            cellProps: {
                class: 'no-padding-x',
            },
            headerProps: {
                class: 'group-header',
            },
            sortable: false,
            minWidth: 0,
            width: 0,
            nowrap: true,
        },
        {
            title: t('pregame.date'),
            value: 'eventDate',
            key: 'eventDate',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('live.timeScore'),
            value: 'timeScore',
            key: 'timeScore',
            align: 'center',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('pregame.game'),
            value: 'gameInfo',
            key: 'gameInfo',
            align: 'start',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('live.stats.yellowCardsShort'),
            value: 'yellowCards',
            key: 'yellowCards',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('live.stats.yellowCards'), class: 'nowrap' },
        },
        {
            title: t('live.stats.redCardsShort'),
            value: 'redCards',
            key: 'redCards',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('live.stats.redCards'), class: 'nowrap' },
        },
        {
            title: t('live.stats.foulsShort'),
            value: 'fouls',
            key: 'fouls',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('live.stats.fouls'), class: 'nowrap' },
        },
        {
            title: t('live.stats.possessionShort'),
            value: 'possession',
            key: 'possession',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('live.stats.possession'), class: 'nowrap' },
        },
        {
            title: t('live.stats.attacksShort'),
            value: 'attacks',
            key: 'attacks',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('live.stats.attacks'), class: 'nowrap' },
        },
        {
            title: t('live.stats.dangerousAttacksShort'),
            value: 'dangerousAttacks',
            key: 'dangerousAttacks',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('live.stats.dangerousAttacks'), class: 'nowrap' },
        },
        {
            title: t('live.stats.shotsShort'),
            value: 'shots',
            key: 'shots',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('live.stats.shots'), class: 'nowrap' },
        },
        {
            title: t('live.stats.shotsOnTargetShort'),
            value: 'shotsOnTarget',
            key: 'shotsOnTarget',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('live.stats.shotsOnTarget'), class: 'nowrap' },
        },
        {
            title: t('live.stats.hitWoodworkShort'),
            value: 'hitWoodwork',
            key: 'hitWoodwork',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('live.stats.hitWoodwork'), class: 'nowrap' },
        },
        {
            title: t('live.stats.cornersShort'),
            value: 'corners',
            key: 'corners',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('live.stats.corners'), class: 'nowrap' },
        },
        {
            title: t('pregame.bookmaker'),
            value: 'bookmakerId',
            key: 'bookmakerId',
            align: 'start',
            sortable: false,
            nowrap: true,
        },
        {
            title: '1',
            value: 'one',
            key: 'one',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.oneXTwo'),
        },
        {
            title: 'X',
            value: 'x',
            key: 'x',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.oneXTwo'),
        },
        {
            title: '2',
            value: 'two',
            key: 'two',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.oneXTwo'),
        },
        {
            title: t('pregame.hdpLine'),
            value: 'hdpLine',
            key: 'hdpLine',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.asianHandicap'),
        },
        {
            title: t('pregame.hdpPriceHome'),
            value: 'hdpPriceHome',
            key: 'hdpPriceHome',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.asianHandicap'),
        },
        {
            title: t('pregame.hdpPriceAway'),
            value: 'hdpPriceAway',
            key: 'hdpPriceAway',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.asianHandicap'),
        },
        {
            title: t('pregame.goalLine'),
            value: 'goalLine',
            key: 'goalLine',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.goal'),
        },
        {
            title: t('pregame.goalPriceOver'),
            value: 'goalPriceOver',
            key: 'goalPriceOver',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.goal'),
        },
        {
            title: t('pregame.goalPriceUnder'),
            value: 'goalPriceUnder',
            key: 'goalPriceUnder',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.goal'),
        },
        {
            title: t('pregame.goalHomeLine'),
            value: 'goalHomeLine',
            key: 'goalHomeLine',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.goalHome'),
        },
        {
            title: t('pregame.goalHomePriceOver'),
            value: 'goalHomePriceOver',
            key: 'goalHomePriceOver',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.goalHome'),
        },
        {
            title: t('pregame.goalHomePriceUnder'),
            value: 'goalHomePriceUnder',
            key: 'goalHomePriceUnder',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.goalHome'),
        },
        {
            title: t('pregame.goalAwayLine'),
            value: 'goalAwayLine',
            key: 'goalAwayLine',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.goalAway'),
        },
        {
            title: t('pregame.goalAwayPriceOver'),
            value: 'goalAwayPriceOver',
            key: 'goalAwayPriceOver',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.goalAway'),
        },
        {
            title: t('pregame.goalAwayPriceUnder'),
            value: 'goalAwayPriceUnder',
            key: 'goalAwayPriceUnder',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.goalAway'),
        },
        {
            title: t('pregame.btsPrices'),
            value: 'btsPrices',
            key: 'btsPrices',
            align: 'center',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('pregame.dnbHome'),
            value: 'dnbPriceHome',
            key: 'dnbPriceHome',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.dnb'),
        },
        {
            title: t('pregame.dnbAway'),
            value: 'dnbPriceAway',
            key: 'dnbPriceAway',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.dnb'),
        },
        {
            title: '1X',
            value: 'dcPrice1x',
            key: 'dcPrice1x',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.dcPrice'),
        },
        {
            title: '12',
            value: 'dcPrice12',
            key: 'dcPrice12',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.dcPrice'),
        },
        {
            title: 'X2',
            value: 'dcPriceX2',
            key: 'dcPriceX2',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.dcPrice'),
        },
        {
            title: t('pregame.cornersHdpLine'),
            value: 'cornersHdpLine',
            key: 'cornersHdpLine',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.cornersAsianHandicap'),
        },
        {
            title: t('pregame.cornersHdpPriceHome'),
            value: 'cornersHdpPriceHome',
            key: 'cornersHdpPriceHome',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.cornersAsianHandicap'),
        },
        {
            title: t('pregame.cornersHdpPriceAway'),
            value: 'cornersHdpPriceAway',
            key: 'cornersHdpPriceAway',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.cornersAsianHandicap'),
        },
        {
            title: t('pregame.cornersGoalLine'),
            value: 'cornersGoalLine',
            key: 'cornersGoalLine',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.cornersGoal'),
        },
        {
            title: t('pregame.cornersGoalPriceOver'),
            value: 'cornersGoalPriceOver',
            key: 'cornersGoalPriceOver',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.cornersGoal'),
        },
        {
            title: t('pregame.cornersGoalPriceUnder'),
            value: 'cornersGoalPriceUnder',
            key: 'cornersGoalPriceUnder',
            align: 'center',
            sortable: false,
            nowrap: true,
            groupTitle: t('pregame.cornersGoal'),
        },
        {
            title: '',
            value: 'actions',
            key: 'actions',
            align: 'end',
            sortable: false,
            nowrap: true,
            width: 96,
            cellProps: {
                class: 'pl-0 pr-1',
            },
        },
    ];
}
